import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-general-video-modal',
  templateUrl: './general-video-modal.component.html',
  styleUrls: ['./general-video-modal.component.scss']
})
export class GeneralVideoModalComponent implements OnInit, OnDestroy {

  @Input() text: string;
  @Input() idVideo: string;

  @ViewChild('showGeneralVideoModal', { static: true }) modal: any; 
  sanitizedUrl!: SafeResourceUrl;


  private showGeneralVideoModalSubscription: Subscription = null;

  constructor(private modalService: NgbModal, public sharedService: SharedService, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.showGeneralVideoModalSubscription = this.sharedService.showGeneralVideoModal.subscribe(show => {
      if (show) this.openModal();
    });
  }

  ngOnChanges(): void {

    if (this.idVideo) {
      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.idVideo}`);
    }
  }

  ngOnDestroy() {

    if (this.showGeneralVideoModalSubscription) { this.showGeneralVideoModalSubscription.unsubscribe(); }
  }

  openModal() {
    this.modalService.open(this.modal, {
      backdrop: 'static', keyboard: false,
      size: 'lg', centered: true, windowClass: 'modal-full'
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
